import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicSelectableModule } from 'ionic-selectable';

import { IonicModule } from '@ionic/angular';

import { ModalAfesMultiplesPage } from './modal-afes-multiples.page';

const routes: Routes = [
  {
    path: '',
    component: ModalAfesMultiplesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    IonicSelectableModule
  ],
  declarations: [ModalAfesMultiplesPage]
})
export class ModalAfesMultiplesPageModule {}
